import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';

export function TrustpilotWidget() {
  const ref = useRef<HTMLDivElement>(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('trustpilot_dismissed') === 'true');

  useEffect(() => {
    if (dismissed) return;

    if ((window as any).Trustpilot) {
      if (ref.current) {
        (window as any).Trustpilot.loadFromElement(ref.current, true);
      }
      return;
    }

    const script = document.createElement('script');
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    script.onload = () => {
      if (ref.current && (window as any).Trustpilot) {
        (window as any).Trustpilot.loadFromElement(ref.current, true);
      }
    };
    document.head.appendChild(script);
  }, [dismissed]);

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('trustpilot_dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-24 left-6 z-40 group">
      <button
        onClick={handleDismiss}
        className="absolute -top-2 -right-2 z-50 flex h-5 w-5 items-center justify-center rounded-full bg-background border border-border shadow-sm opacity-0 group-hover:opacity-100 transition-opacity"
        aria-label="Fermer"
      >
        <X size={12} className="text-muted-foreground" />
      </button>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="fr-FR"
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id="691d81d0fb3981c964efbab5"
        data-style-height="52px"
        data-style-width="100%"
        data-token="6408d013-4e77-4e06-8ed1-ab10dec3c3fc"
      >
        <a
          href="https://fr.trustpilot.com/review/no-codeo.com"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
}
